import React from 'react';
import { RotatingLines } from 'react-loader-spinner';
import styled, { keyframes, css } from "styled-components";

const Loadingcontainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    padding-top: 24px;
    padding-bottom: 24px;
`
const Loading = () => {
    return (
        <Loadingcontainer>
            <RotatingLines
                strokeColor="#444"
                strokeWidth="4"
                animationDuration="1"
                width="35"
                visible={true}
            />
        </Loadingcontainer>
    );
};

export default Loading;